export enum KeyboardKey {
  Escape = "Escape",
  Enter = "Enter",
}